import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface LegalPageProps {
  title: string;
  lastUpdated: string;
  backHref: string;
  children: React.ReactNode;
}

const LegalPage: React.FC<LegalPageProps> = ({ title, lastUpdated, backHref, children }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      {/* Top bar */}
      <div className="bg-mas10-primary">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link
            to={backHref}
            className="inline-flex items-center text-white/80 hover:text-white text-sm font-medium transition-colors"
          >
            {t('legal.back_home')}
          </Link>
        </div>
      </div>

      {/* Header */}
      <div className="bg-gradient-to-br from-mas10-primary to-blue-800 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          <Link to={backHref} className="inline-block mb-6">
            <img src="/logo_trainer.png" alt="+Trainer" className="h-9 w-auto object-contain brightness-0 invert" />
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold font-display leading-tight">{title}</h1>
          <p className="mt-3 text-white/70 text-sm">
            {t('legal.last_updated')}: {lastUpdated}
          </p>
        </div>
      </div>

      {/* Rich content */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {children}
      </div>

      {/* Footer strip */}
      <div className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center text-gray-500 text-sm">
          © {new Date().getFullYear()} +Trainer. {t('footer.rights')}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
